/* eslint-disable react/prop-types */

import React from 'react';

const NoResults = ({ text }) => <div className='no-results'>{text}</div>;

export default NoResults;
